import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';
import { RootState, useAppDispatch } from '../store';

import { useSelector } from 'react-redux';
import { toggleClass } from '../common/Utils';
import useClickAway from '../hook/useClickAway';
import useRouter from '../hook/useRouter';
import { setDetailEnchant, setDetailId, setDetailNow, setDetailSvr, setItemInfo } from '../store/detailSlice';
import { DETAIL_STATE } from './common/ConstList';
import { Title } from './type_item/Title';

const ItemIdxLm = lazy(() => import('./type_item/ItemIndexLm'));
const ItemIdxTl = lazy(() => import('./type_item/ItemIndexTl'));
const SkillIdxTl = lazy(() => import('./type_skill/SkillIndexTl'));

export const Index = () => {
    const dispatch = useAppDispatch();
    const service = useSelector((state: RootState) => state.main.config.service);

    const [isShow, isShowSet] = useState(false);
    const now = useSelector((state: RootState) => state.detail.detailNow);
    const detailId = useSelector((state: RootState) => state.detail.detailId);
    const { params, getValue, changeParam } = useRouter(['detail']);

    const conRef = useRef<HTMLDivElement>(null);
    const secRef = useRef<HTMLDivElement>(null);
    const wrapRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!params) return;
        const detailState = getValue('detail');

        let tempArr: string[] = detailState.split('_');
        const now = tempArr.shift();
        const svr = tempArr.pop();
        const enc = tempArr.pop();
        const id = tempArr.join('_');

        dispatch(setDetailNow(now));
        dispatch(setDetailId(id));
        dispatch(setDetailEnchant(enc));
        dispatch(setDetailSvr(svr));
    }, [params]);

    useEffect(() => {
        isShowSet(detailId !== '' && detailId !== undefined && detailId !== '0');
    }, [detailId]);

    useEffect(() => {
        toggleClass(conRef.current, 'is-active', isShow);
        document.querySelector('body')!.style.overflow = isShow ? 'hidden' : '';
    }, [isShow]);

    useEffect(() => {
        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                secRef.current?.scrollTo({ top: 0 });
                changeParam({ detail: '' });
                dispatch(setItemInfo(null));
            }
        });
    }, []);

    useClickAway(wrapRef, (e) => {
        const target = e.target as HTMLElement;
        if (target.className === 'toast-cancel') return;

        if (isShow) {
            secRef.current?.scrollTo({ top: 0 });
            changeParam({ detail: '' });
            dispatch(setItemInfo(null));
        }
    });

    return (
        <div className="gameinfo-detail-wrapper" ref={conRef}>
            <div className="gameinfo-detail" ref={wrapRef}>
                <Title />
                <div className="gameinfo-detail__section" ref={secRef}>
                    {isShow ? (
                        <Suspense
                            fallback={
                                <div className="gameinfo-loader is-show">
                                    <span className="loader"></span>
                                </div>
                            }
                        >
                            {now === DETAIL_STATE.ITEM && service === 'lms' ? <ItemIdxLm /> : null}
                            {now === DETAIL_STATE.ITEM && service === 'l2m' ? <ItemIdxLm /> : null}
                            {now === DETAIL_STATE.ITEM && service === 'tl' ? <ItemIdxTl /> : null}
                            {now === DETAIL_STATE.SKILL && service === 'tl' ? <SkillIdxTl /> : null}
                        </Suspense>
                    ) : null}
                </div>
            </div>
        </div>
    );
};
